import { Row, Col, Form } from "react-bootstrap";
import CustomAutoCompleteCartaPorte from "../../../../components/formik/CustomAutoCompleteCartaPorte";
import moment from "moment";
import { useEffect } from "react";

const UbicacionFormFields = ({
  formik,
  findColoniasByPostal,
  findMunicipalitiesByState,
  findPostalCode,
  findStates,
}) => {
  const { values, errors, touched, handleChange, setFieldValue } = formik;

  // Resetear colonia cuando cambia el código postal origen
  useEffect(() => {
    setFieldValue("coloniaOrigen", null);
  }, [values.codigoPostalOrigen?.id, setFieldValue]);

  // Resetear municipio cuando cambia el estado origen
  useEffect(() => {
    setFieldValue("municipioOrigen", null);
  }, [values.estadoOrigen?.id, setFieldValue]);

  // Resetear colonia cuando cambia el código postal destino
  useEffect(() => {
    setFieldValue("coloniaDestino", null);
  }, [values.codigoPostalDestino?.id, setFieldValue]);

  // Resetear municipio cuando cambia el estado destino
  useEffect(() => {
    setFieldValue("municipioDestino", null);
  }, [values.estadoDestino?.id, setFieldValue]);

  return (
    <>
      {/* ORIGEN */}
      <h5>Origen</h5>
      <Row className="mb-3">
        <Form.Group as={Col} md="3" controlId="fechaHoraSalidaOrigen">
          <Form.Label>Fecha y hora de salida</Form.Label>
          <Form.Control
            type="datetime-local"
            name="fechaHoraSalidaOrigen"
            value={
              values.fechaHoraSalidaOrigen
                ? moment(values.fechaHoraSalidaOrigen).format(
                    "YYYY-MM-DDTHH:mm"
                  )
                : ""
            }
            onChange={handleChange}
            isInvalid={
              touched.fechaHoraSalidaOrigen && !!errors.fechaHoraSalidaOrigen
            }
            step="1"
            // max={moment().format("YYYY-MM-DDTHH:mm")}
          />
          <Form.Control.Feedback type="invalid">
            {errors.fechaHoraSalidaOrigen}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="3" controlId="paisOrigen">
          <Form.Label>País *</Form.Label>
          <Form.Control
            type="text"
            name="paisOrigen"
            value={values.paisOrigen}
            onChange={handleChange}
            isInvalid={touched.paisOrigen && !!errors.paisOrigen}
            disabled={true}
          />
          <Form.Control.Feedback type="invalid">
            {errors.paisOrigen}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="3" controlId="estadoOrigen">
          <CustomAutoCompleteCartaPorte
            formik={formik}
            field="estadoOrigen"
            label="Estado"
            searchFunction={findStates}
            descriptionField="nombre"
            idDisplayFormatter={(id, item) => item.id}
          />
          {errors.estadoOrigen && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.estadoOrigen}
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <Form.Group as={Col} md="3" controlId="municipioOrigen">
          <CustomAutoCompleteCartaPorte
            key={values.estadoOrigen?.id}
            formik={formik}
            field="municipioOrigen"
            label="Municipio"
            searchFunction={(term) =>
              findMunicipalitiesByState(values.estadoOrigen.id, term)
            }
            idDisplayFormatter={(id, item) => item.c_Estado}
          />
          {errors.municipioOrigen && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.municipioOrigen}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="3" controlId="codigoPostalOrigen">
          <CustomAutoCompleteCartaPorte
            formik={formik}
            field="codigoPostalOrigen"
            label="Código Postal"
            searchFunction={findPostalCode}
            descriptionField="descripcion"
          />
          {errors.codigoPostalOrigen && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.codigoPostalOrigen}
            </Form.Control.Feedback>
          )}
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="coloniaOrigen">
          <CustomAutoCompleteCartaPorte
            key={values.codigoPostalOrigen?.id}
            formik={formik}
            field="coloniaOrigen"
            label="Colonia"
            searchFunction={(term) =>
              findColoniasByPostal(values.codigoPostalOrigen.id, term)
            }
            descriptionField="nombreAsentamiento"
            idDisplayFormatter={(id, item) => item.c_CodigoPostal}
          />
          {errors.coloniaOrigen && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.coloniaOrigen}
            </Form.Control.Feedback>
          )}
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="calleOrigen">
          <Form.Label>Calle *</Form.Label>
          <Form.Control
            type="text"
            name="calleOrigen"
            value={values.calleOrigen}
            onChange={handleChange}
            isInvalid={touched.calleOrigen && !!errors.calleOrigen}
          />
          <Form.Control.Feedback type="invalid">
            {errors.calleOrigen}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* DESTINO */}
      <h5>Destino</h5>
      <Row className="mb-3">
        <Form.Group as={Col} md="3" controlId="fechaHoraLlegadaDestino">
          <Form.Label>Fecha y hora de llegada</Form.Label>
          <Form.Control
            type="datetime-local"
            name="fechaHoraLlegadaDestino"
            value={
              values.fechaHoraLlegadaDestino
                ? moment(values.fechaHoraLlegadaDestino).format(
                    "YYYY-MM-DDTHH:mm"
                  )
                : ""
            }
            onChange={handleChange}
            isInvalid={
              touched.fechaHoraLlegadaDestino &&
              !!errors.fechaHoraLlegadaDestino
            }
            step="1"
            // max={moment().format("YYYY-MM-DDTHH:mm")}
          />
          <Form.Control.Feedback type="invalid">
            {errors.fechaHoraLlegadaDestino}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="3" controlId="paisDestino">
          <Form.Label>País *</Form.Label>
          <Form.Control
            type="text"
            name="paisDestino"
            value={values.paisDestino}
            onChange={handleChange}
            isInvalid={touched.paisDestino && !!errors.paisDestino}
            disabled={true}
          />
          <Form.Control.Feedback type="invalid">
            {errors.paisDestino}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="3" controlId="estadoDestino">
          <CustomAutoCompleteCartaPorte
            formik={formik}
            field="estadoDestino"
            label="Estado"
            searchFunction={findStates}
            descriptionField="nombre"
            idDisplayFormatter={(id, item) => item.id}
          />
          {errors.estadoDestino && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.estadoDestino}
            </Form.Control.Feedback>
          )}
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="municipioDestino">
          <CustomAutoCompleteCartaPorte
            key={values.estadoDestino?.id}
            formik={formik}
            field="municipioDestino"
            label="Municipio"
            searchFunction={(term) =>
              findMunicipalitiesByState(values.estadoDestino.id, term)
            }
            idDisplayFormatter={(id, item) => item.c_Estado}
          />
          {errors.municipioDestino && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.municipioDestino}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="3" controlId="codigoPostalDestino">
          <CustomAutoCompleteCartaPorte
            formik={formik}
            field="codigoPostalDestino"
            label="Código Postal"
            searchFunction={findPostalCode}
            descriptionField="descripcion"
          />
          {errors.codigoPostalDestino && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.codigoPostalDestino}
            </Form.Control.Feedback>
          )}
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="coloniaDestino">
          <CustomAutoCompleteCartaPorte
            key={values.codigoPostalDestino?.id}
            formik={formik}
            field="coloniaDestino"
            label="Colonia"
            searchFunction={(term) =>
              findColoniasByPostal(values.codigoPostalDestino.id, term)
            }
            descriptionField="nombreAsentamiento"
            idDisplayFormatter={(id, item) => item.c_CodigoPostal}
          />
          {errors.coloniaDestino && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.coloniaDestino}
            </Form.Control.Feedback>
          )}
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="calleDestino">
          <Form.Label>Calle *</Form.Label>
          <Form.Control
            type="text"
            name="calleDestino"
            value={values.calleDestino}
            onChange={handleChange}
            isInvalid={touched.calleDestino && !!errors.calleDestino}
          />
          <Form.Control.Feedback type="invalid">
            {errors.calleDestino}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="3" controlId="DistanciaRecorrida">
          <Form.Label>Distancia Recorrida (km) *</Form.Label>
          <Form.Control
            type="number"
            name="DistanciaRecorrida"
            value={values.DistanciaRecorrida}
            onChange={handleChange}
            isInvalid={
              touched.DistanciaRecorrida && !!errors.DistanciaRecorrida
            }
            min="0"
            step="0.01"
          />
          <Form.Control.Feedback type="invalid">
            {errors.DistanciaRecorrida}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

export default UbicacionFormFields;
